module.exports = __webpack_public_path__ + "static/media/045-smartphone-4.3e7e1f11.svg";